import { FastlyImage } from '@components/common/image'
import Spinner from '@components/common/spinner'
import { CalendarIcon } from '@components/student-dashboard/course-modules/lesson-card'
import { DATE_TIME_FORMAT } from '@lib/constants/common'
import { RESCHEDULE_CLASS_IMAGE_PATH } from '@lib/constants/reschedule-class'
import { ClassScheduleType } from '@lib/types/reschedule'
import { formatTimeByTimezone } from '@lib/utils/date.utils'
import Router from 'next/router'
import AlertMessage from '@components/atoms/alert-message'

type Props = {
  scheduleOfUpcomingClasses: ClassScheduleType[]
  isLoading: boolean
  isTeacher: boolean
  studentName?: string
  selectedTimezone: string
  rescheduleRequestedBy: 'student' | 'teacher' | null
}

const RescheduleSuccess = ({
  scheduleOfUpcomingClasses,
  isLoading,
  isTeacher,
  selectedTimezone,
  rescheduleRequestedBy,
}: Props) => (
  <div className="flex flex-col items-center space-y-5 leading-tight">
    <FastlyImage
      src={`${RESCHEDULE_CLASS_IMAGE_PATH}calendar-success.png`}
      width={100}
      height={100}
    />
    <p className="self-start text-xl font-600">
      {isTeacher ? (
        'Your class has been rescheduled successfully.'
      ) : (
        <>
          Your classes have been rescheduled. <br />
          Don’t miss your next class!
        </>
      )}
    </p>
    {isLoading ? (
      <Spinner classes="w-6 h-6 text-orange" />
    ) : (
      <>
        {isTeacher && (
          <div className="flex flex-col items-start w-full">
            <p>
              <span className="font-600">
                Lesson
                {scheduleOfUpcomingClasses?.[0]?.lessonNumber &&
                  ` ${scheduleOfUpcomingClasses?.[0]?.lessonNumber}`}
                :{' '}
              </span>
              {scheduleOfUpcomingClasses?.[0]?.lessonTitle}
            </p>
            <p>
              <span className="font-600">Time:</span>{' '}
              {formatTimeByTimezone(
                scheduleOfUpcomingClasses?.[0]?.startTime,
                selectedTimezone,
                DATE_TIME_FORMAT
              )}
            </p>
            <p>
              <span className="font-600">Student:</span>{' '}
              {scheduleOfUpcomingClasses?.[0]?.studentName}
            </p>
          </div>
        )}
        {!isTeacher && (
          <>
            <p className="self-start font-600">
              Schedule of next {scheduleOfUpcomingClasses.length}{' '}
              {scheduleOfUpcomingClasses.length > 1 ? 'classes' : 'class'}:
            </p>
            <div className="flex flex-col self-start">
              {scheduleOfUpcomingClasses.map(
                ({ startTime, lessonTitle, lessonNumber }) => (
                  <div
                    key={startTime}
                    className="flex items-center py-3 pl-2 space-x-2 border-t border-grey-500"
                  >
                    <CalendarIcon
                      selectedDate={startTime}
                      isInRescheduleModal
                    />
                    <div className="flex flex-col">
                      <p className="font-600">Lesson: {lessonNumber}</p>
                      <p>{lessonTitle}</p>
                    </div>
                  </div>
                )
              )}
            </div>
          </>
        )}
      </>
    )}
    {isTeacher && rescheduleRequestedBy === 'teacher' && (
      <AlertMessage className="leading-tight">
        A penalty will be imposed if your cancellation limit has been reached.
      </AlertMessage>
    )}
    <button
      className="text-white bg-green-200 btn hover:bg-green-100"
      onClick={() => Router.reload()}
    >
      {isTeacher ? 'Back to calendar' : 'Back to Dashboard'}
    </button>
  </div>
)

export default RescheduleSuccess
